import notification_snackbar from "~/components/shared/snackbar/notificationTemplate"
import messages from "~/components/notification/messages"

export default {
  components: { notification_snackbar },
  methods: {
    createSnackbar: function (notification) {
      let payload = {
        component: notification_snackbar,
        class: { notificationSnackbarStyle: true },
        props: {
          picture: notification.context.picture,
          sender: notification.context.sender,
          message: this.message(notification),
          notification,
        },
      }
      this.$store.dispatch("snackbar/CREATE", payload)
    },
    message: function (notification) {
      const key = notification.kind
      const build = messages[key]

      if (typeof build === "function")
        return build(notification.context, this.$store.state.locale)
      else return ""
    },
  },
}
